module.exports = __webpack_public_path__ + "img/symbol_s06.d635090.svg";